import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NewsFeatures from './NewsFeatures';
import NewsVideos from './NewsVideos';

const News = ({children, className}) => {
    return (
        <div className={classNames('News', className)}>
            <NewsFeatures />
            <NewsVideos />
        </div>
    );
};

News.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
};

export default News;
